import { Chip, TableCell } from '@mui/material';
import { AssemblyStatus } from 'src/interfaces';
import { theme } from 'src/utils';

export const AssemblyStatusChip = ({ status }: { status: AssemblyStatus }) => {
  return (
    <TableCell>
      <Chip
        label={status}
        sx={{
          backgroundColor:
            theme.status[status.toLowerCase() as keyof typeof theme.status]
              .light,
          color:
            theme.status[status.toLowerCase() as keyof typeof theme.status]
              .dark,
        }}
        size="small"
      />
    </TableCell>
  );
};
